<template>
  <v-dialog
    v-model="showDialog"
    max-width="800px"
  >

  <v-form
      ref="form"
      v-model="valid"
      @keyup.native.enter.prevent="valid && save()"
      :disabled="loading"
    >

    <v-card>
      <v-card-title>
        <span class="headline">Nueva planificación diaria (consolidar)</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center text-h6">
              <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="fecha"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.fecha"
                        prepend-icon="mdi-calendar-month"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                        placeholder="Fecha"
                        dense
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.fecha"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(fecha)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
            </v-col>

            <v-col cols="12" class="text-center text-h6">
              <v-text-field
                label="Título"
                v-model="form.titulo"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" class="text-center text-h6">
              <v-textarea
                    counter
                    label="Nota"
                    v-model="form.nota"
                  >
                  </v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="error"
          dark
          @click="close"
          :disabled="loading"
        >
        <v-icon small>mdi-cancel</v-icon>
          <v-divider class="mx-4" inset vertical></v-divider>
            Cerrar
      </v-btn>

      <v-btn
            form="form"
            color="blue darken-1 white--text"
            @click="save"
            :loading="loading"
            :disabled="!valid || loading"
          >
            <v-icon small>mdi-content-save</v-icon>
            <v-divider class="mx-4" inset vertical></v-divider>
           Guardar
          </v-btn>
      </v-card-actions>

    </v-card>
  
    </v-form>

  </v-dialog>
</template>
<script>
  import messageMixin from "@/mixins/common"
  import HTTP from "@/http"

  export default {
    props: {
      despachos: null,
    },
    mixins: [messageMixin],
    data() {
      return {
        valid: false,
        showDialog: false,
        loading: false,
        form: {
          titulo:null,
          nota: null,
          fecha: new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000,
          )
            .toISOString()
            .substr(0, 10),
        },
        
        rules: {
          required: (value) => !!value || "Requerido.",
        }
      }
    },

    methods: {
      close() {
        this.showDialog = false
      },

      async save() {
        try {
          let data = {
            fecha: this.form.fecha,
            titulo: this.form.titulo,
            nota: this.form.nota,
            despacho: this.$props.despachos        
          };
          
          this.loading = true;

          let response = await HTTP().post("/planificar-despacho/consolidar", data);

          if (response.data.code === 201) {
            this.saveMessage("Planifiacación consolidada");
          }

          this.loading = false
          this.close()
          this.resetForm()
        } catch (error) {
          this.errorMessage(this.messageError)
          this.close()
          this.resetForm()
        }
      },

      resetForm() {
        this.form.titulo = null;
        this.form.nota = null;
        this.form.fecha = null;
      }
    },
  }
</script>